module.exports = global["moment"] = require("-!./moment.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/moment/moment.js-exposed
// module id = 1
// module chunks = 46 47